export default __webpack_public_path__ + "static/media/truck.b0f6e788.svg";